export default (html) => {
  try {
    const metaTags = html.split('>');
    const result = [];

    for (let i = 0; i < metaTags.length; i += 1) {
      const tag = metaTags[i];
      if (tag.includes('meta') && tag.includes('name="') && tag.includes('content="')) {
        const namePart = tag.split('name="')[1];
        const name = namePart.split('"')[0];

        const contentPart = tag.split('content="')[1];
        const content = contentPart.split('"')[0];

        result.push({
          name,
          content,
        });
      }
    }

    return result;
  } catch {
    return null;
  }
};
